import Qs from 'qs';

const convertToArray = object => {
  const array = Object.keys(object).map(key => ({
    key,
    values: object[key],
  }));
  return array.filter(({ values }) => values);
};

export default {
  async fetchData({ commit, state }, { type }) {
    try {
      commit('layout/setLoader', true, { root: true });
      commit('setLoading', {
        type,
        value: true,
      });
      const params = {
        ...(state[type].pagination.limit && { limit: state[type].pagination.limit }),
        ...(state[type].pagination.offset && { offset: state[type].pagination.offset }),
        ...(state[type].sort.value && { orderBy: state[type].sort.value }),
        ...(state[type].sort.direction && { orderDirection: state[type].sort.direction }),
        ...(state[type].scope && { scope: state[type].scope }),
        filters: convertToArray(state[type].activeFilters),
      };
      let result = null;

      let items = [];

      if (type === 'invoices') {
        result = await this.$axios.get(`${this.$config.baseOfixApi}/e-commerce/v1/sales-invoices`, {
          params,
          paramsSerializer: params => {
            return Qs.stringify(params);
          },
        });
        items = result.data.salesInvoices;
      } else if (type === 'orders') {
        result = await this.$axios.get(`${this.$config.baseOfixApi}/e-commerce/v1/sales-orders`, {
          params,
          paramsSerializer: params => {
            return Qs.stringify(params);
          },
        });
        items = result.data.salesOrders;
      } else if (type === 'ordersToAcceptance') {
        result = await this.$axios.get(
          `${this.$config.baseOfixApi}/e-commerce/v1/sales-orders/order-for-acceptance`,
          {
            params,
            paramsSerializer: params => {
              return Qs.stringify(params);
            },
          },
        );
        items = result.data.salesOrders;
      } else if (type === 'complaints') {
        result = await this.$axios.get(`${this.$config.baseOfixApi}/e-commerce/v1/complaints`, {
          params,
          paramsSerializer: params => {
            return Qs.stringify(params);
          },
        });
        items = result.data.complaints;
      }
      commit('setPagination', {
        type,
        value: {
          ...state[type].pagination,
          countTotal: result.data.countTotal,
        },
      });
      commit('setItems', { type, value: items });

      if (result.data.availableFilters) {
        commit('setAvailableFilters', { type, value: result.data.availableFilters });
      }
      commit('layout/setLoader', false, { root: true });
      commit('setLoading', {
        type,
        value: false,
      });
    } catch {
      commit('setLoading', {
        type,
        value: false,
      });
      commit('layout/setLoader', false, { root: true });
    }
  },

  async changeFilters({ commit, dispatch, state }, { type, name, value }) {
    try {
      commit('setFilter', { type, name, value });
      commit('setPagination', { type, value: { ...state[type].pagination, offset: 0 } });
      await dispatch('fetchData', { type });
    } catch {}
  },

  async changePagination({ commit, dispatch }, { type, value }) {
    try {
      commit('setPagination', { type, value });
      await dispatch('fetchData', { type });
    } catch {}
  },

  async changeSort({ state, commit, dispatch }, { type, value }) {
    try {
      commit('setSort', { type, value });
      commit('setPagination', { type, value: { ...state[type].pagination, offset: 0 } });
      await dispatch('fetchData', { type });
    } catch {}
  },
};
